
import { apiGet, apiPost, apiPatch, apiPut, apiDelete } from "../utils/axios";
import { domainUrl } from "../utils/domainUrls";

export default {
  getCalender: (searchQuery = "", statusFilter = "") => {
    const params = new URLSearchParams();
    
    if (searchQuery) {
      params.append('search', searchQuery);
    }
    
    if (statusFilter && statusFilter !== "All Statuses") {
      params.append('watched', statusFilter);
    }
    
    const queryString = params.toString();
    const url = queryString ? `/v1/calender?${queryString}` : '/v1/calender';
    
    return apiGet(domainUrl(url));
  },

};
